import React, {useContext, useLayoutEffect, useState} from "react";
import {MapContext, Popup} from "react-mapbox-gl";

interface PopupData {
    lngLat: mapboxgl.LngLat;
    properties: GeoJSON.GeoJsonProperties | undefined;
}

export const MarkerPopup = () => {
    const [popupData, setPopupData] = useState<PopupData|null>(null);
    const map = useContext(MapContext);

    useLayoutEffect(() => {
      ["delivery-marker", "operator-active-hub-marker", "operator-inactive-hub-marker",
      "carrier-active-hub-marker", "carrier-inactive-hub-marker", "pickup-marker"].forEach((id)=>{
        map?.on("click", id, (event) => {
          setPopupData({
            lngLat: event.lngLat,
            properties: event.features?.at(0)?.properties ? { ...event.features.at(0)!.properties } : undefined,
          });
        });
      })
    }, [map]);

    return (
      popupData && (
        <Popup
          key={`${popupData.lngLat.lng},${popupData.lngLat.lat}`}
          coordinates={popupData.lngLat}
          onClick={() => {
            setPopupData(null);
          }}
        >
          {getPopupContent(popupData.properties)}
        </Popup>
      )
    );
};

const getPopupContent = (properties: (GeoJSON.GeoJsonProperties | undefined)): JSX.Element => {
    if (properties?.nbColis) {
        return (
        <p>
            Nombre de colis livrés : {properties?.nbColis ?? 0}
        </p>
        )
    } else if (properties?.hubType) {
        const type = properties?.hubType ?? null
        let name = ""
        switch (type) {
        case "OPERATOR_ACTIVE_HUB":
            name = "Espace de Logistique Urbaine"
            break;
        case "OPERATOR_INACTIVE_HUB":
            name = "Espace de Logistique Urbaine"
            break;
        case "CARRIER_ACTIVE_HUB":
            name = "Entrepôt"
            break;
        case "CARRIER_INACTIVE_HUB":
            name = "Entrepôt"
            break;
        }
        console.log("properties", properties)
        return (
        <p>
            {name}<br/>
            <span style={{color: "grey"}}>{properties?.hubOrganizationName ?? ""}</span><br/>
            {properties?.hubActivityEndDate > 0 ? <b style={{color: "red"}}>INACTIF</b> : <b style={{color: "green"}}>ACTIF</b>}
        </p>
        )
    } else {
        return (
        <p>
            <b style={{fontSize: "14px"}}>Hub détecté automatiquement</b><br/>
            <i>(plus de 100 colis ayant transités par ce point)</i>
        </p>
        )
    }
}
